import { useState, useEffect } from "react";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import { toast } from "components/ui/use-toast";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { MESSAGES } from "../utils/messages";
import { useUpdateRegionalMutation } from "@/services/regional";
import { IRegional } from "src/@types/regional";

function Update({ row }: { row: IRegional }) {
  const [updateRegional, { isLoading }] = useUpdateRegionalMutation();
  const { handleModal } = useDialogModal();

  const [name, setName] = useState(row?.name || "");
  const [email, setEmail] = useState(row?.email || "");
  const [error, setError] = useState<string | null>(null);

  const validateForm = () => {
    if (!name.trim()) {
      setError("O nome é obrigatório.");
      return false;
    }
    setError(null);
    return true;
  };

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    try {
      await updateRegional({ id: +row.id, name, email }).unwrap();

      toast(MESSAGES.UPDATE.SUCCESS);

      handleModal({
        isOpen: false,
      });
    } catch (e) {
      console.error("Erro ao atualizar:", e);
      handleModal({
        isOpen: false,
      });
      toast(MESSAGES.UPDATE.ERROR);
    }
  };

  useEffect(() => {
    if (row) {
      setName(row.name || "");
    }
  }, [row]);

  return (
    <div className="grid gap-4 min-w-[300px]">
      <form onSubmit={onSubmit}>
        <div className="space-y-4">
          <div className="flex flex-col gap-2">
            <Input
              value={name}
              onChange={(e) => setName(e.target.value)}
              hasError={!!error}
              placeholder="Escreva a regional."
            />
            <Input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              hasError={!!error}
              type="email"
              placeholder="Escreva o e-mail"
            />
          </div>
          <div className="flex w-full justify-end gap-4">
            <button
             className="self-end w-max px-4 py-2 border border-black/20 flex items-center gap-2 rounded-md
             text-black bg-white
             transition-all duration-300 ease-in-out
             hover:bg-[#2B0C1A] hover:text-white hover:border-transparent
             "
              onClick={() => {
                setName(row?.name || "");
                handleModal({ isOpen: false });
              }}
            >
              Voltar
            </button>
            <Button type="submit" variant="default" isLoading={isLoading}>
              Salvar
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default Update;
